export default __webpack_public_path__ + "static/media/knife.3a62c9dc.png";